'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M64 64h256v256h-256zM384 64h256v256h-256zM704 64h256v256h-256zM64 384h256v256h-256zM384 384h256v256h-256zM704 384h256v256h-256zM64 704h256v256h-256zM384 704h256v256h-256zM704 704h256v256h-256z' })
    ));
};